import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Row, Col, Divider, Descriptions, Input, Select, Space, Radio, Flex, Checkbox, } from 'antd';
import { BaseContainer } from 'components/containers';
import { OutlinedButton, FillButton, BaseDatePicker } from 'components/elements';
import { UploadFile, } from 'pages/common';
import { BaseSection } from 'components/layouts';
import { getSchoolDetailAPI, putSchoolAPI } from 'api/school';
import { storeSchoolTypeOptions, schoolStatus, homePhoneOptions, bankCodeOptions, emailOptions, yearOptions,  } from 'data/options';
import AddressModal from 'components/containers/AddressModal';
import { objToLowerCase, fnSeparatePhone, fnSeparateEmail,  fnCombinePhone,fnCombineEmail,
  formatNum, fnCombineBusinessNo,fnSeparateBusinessNo, fnVaildationCheck,   } from 'utils/utils';
import {URL_ADMIN,URL_ADMIN_SCHOOL,URL_ADMIN_SCHOOL_MANAGE} from 'routes/AdminRoute';
import { getBranchListAPI } from 'api/common';

const { TextArea } = Input;

export default function SchoolManageEdit({ onToList, searchParam }) {
  const navigate = useNavigate();
  const { no } = useParams();
  const { state } = useLocation();
  const [data, setData] = useState(searchParam);
  const [branchList, setBranchList] = useState([]);
  const [tab, setTab] = useState(state?.tab)

  const fnUpdateSchoolData = (v)=>{
    setData({...data, ...v})
  };
  
  const fnSetEmail = (v) => {
    let auto = v ? true : false
    setData({...data, email: {...data?.email, addr: v, auto}}) 
  }

  const fnPasswordCheck = (e) => {
    const value = e.target.value
    setData({...data, pw_check: value, ...(data?.pw !== value && value?.length > 0 ? { pw_status: 'error', pw_message: '비밀번호 불일치' } : { pw_status: '', pw_message: '' }) });
  };

  const fnUpdateData = async () => {
    const params = {
      ...data,
      cell_phone: fnCombinePhone(data?.cell_phone),
      home_phone: fnCombinePhone(data?.home_phone),
      email: fnCombineEmail(data?.email),
      business_no : fnCombineBusinessNo(data?.business_no),
      observe_edu: null
    }

    if (data?.pw_message || (data?.pw?.length > 0 && !data?.pw_check?.length > 0)) {
      alert('비밀번호를 확인해주세요.')
      return 
    }

    if(fnVaildationCheck([data?.school_type, data?.addr, data?.school_status, data?.school_leader_name, data?.cell_phone?.middle, data?.cell_phone?.last]
      ,["가맹유형", "주소", "교육원 상태", "교육원장명", "휴대폰번호", "휴대폰번호"])) {
        await putSchoolAPI(params).then((res) => {
          if (res.data.responseCode === 200) {
            alert('수정되었습니다.');
            navigate(`${URL_ADMIN + URL_ADMIN_SCHOOL}${URL_ADMIN_SCHOOL_MANAGE}`, {state: {tab: tab}})
          }
        })
        .catch (err => {
          console.error(err);
        })
    }
  };

  const fnGetBranchList = async () => {
    try {
      const { data: res } = await getBranchListAPI()
      const branch_list = res.data_list?.map(it => ({label: it.BRANCH_NAME, value: it.IDX}))
      setBranchList(branch_list)
    } catch (err) {
      console.eror(err)
    }
  }

  const fnGetDetail = async () => {
    await getSchoolDetailAPI(no)
    .then(res => {
      // console.log(res);
      const {data_info} = res.data;
      const gender = 'M'
      setData(objToLowerCase({
        ...searchParam, 
        ...data_info,
        cell_phone: fnSeparatePhone(data_info?.CELL_PHONE) || {first: '010'},
        home_phone: fnSeparatePhone(data_info?.HOME_PHONE) || {first: '02'},
        email: fnSeparateEmail(data_info?.EMAIL),
        business_no : fnSeparateBusinessNo(data_info?.BUSINESS_NO),
        gender: data_info?.GENDER ? data_info?.GENDER : gender
      }));
    })
    .catch(err => {
      console.error(err);
    })
  }

  useEffect(() => {
    setTab(tab)
    fnGetBranchList()
    fnGetDetail();
  }, [state?.tab])

  const items1 = [
    {
      key: '1',
      label: '아이디',
      children: <Input value={data?.school_id} style={{ width: '30rem' }} disabled />,
      span: 3
    },
    {
      key: '2',
      label: '비밀번호',
      children: (
        <Space>
          <Input.Password value={data?.pw} status={data?.pw_status} placeholder={data?.pw_message} style={{ width: '30rem' }} onChange={(e) => fnUpdateSchoolData({pw: e.target.value })} />
          <div className={'text-reference'}>※ 변경을 원할경우만 입력하세요</div>
        </Space>
      )
    },
    {
      key: '3',
      label: '비밀번호 확인',
      children: 
        <Space>
          <Input.Password value={data?.pw_check} status={data?.pw_status} placeholder={data?.pw_message} style={{ width: '30rem' }} onChange={(e) => fnPasswordCheck(e)} />
          <div className={['pw-show', data?.pw_status].join(' ')}>{data?.pw_message}</div>
        </Space>
    },
    {
      key: '4', span: 2,
      label: '지사',
      children: (
        <Flex vertical={true} gap={'3px'}>
          <Input 
            style={{ width: '25%' }}
            value={data?.branch_name}
            disabled
          />
          <Flex align={'center'} wrap gap={'5px'}>
            <Select
              showSearch
              placeholder={'이동할 지사를 선택하세요.'}
              optionFilterProp="label"
              value={data?.apply_branch_idx}
              style={{ width: '25%' }}
              disabled={!data?.isMove}
              options={branchList}
              onChange={v => fnUpdateSchoolData({apply_branch_idx: v})}
            />
            <Checkbox 
              checked={data?.isMove} 
              onChange={(e) => e.target.checked ? fnUpdateSchoolData({isMove: e.target.checked}) : fnUpdateSchoolData({isMove: e.target.checked, apply_branch_idx: null}) }
            >
              이동
            </Checkbox>
          </Flex>
        </Flex>
      )
    },
    {
      key: '5', span:2,
      label: '교육원명',
      children: <Input value={data?.school_name} style={{ width: '30rem' }} onChange={e=>fnUpdateSchoolData({school_name: e.target.value})} disabled />
    },
    {
      key: '6',
      label: '전화번호',
      children: (
        <Space>
          <Select
            value={data?.home_phone?.first}
            style={{ width: '10rem' }}
            options={homePhoneOptions}
            onSelect={(v) => fnUpdateSchoolData({home_phone: {...data?.home_phone, first: v}})}
          />       
          <Input 
            style={{ width: '13.5rem' }} 
            value={data?.home_phone?.middle}
            onChange={(e) => fnUpdateSchoolData({home_phone: {...data?.home_phone, middle: formatNum(e.target.value)}})}
          /> 
          - 
          <Input 
            style={{ width: '13.5rem' }} 
            value={data?.home_phone?.last}
            onChange={(e) => fnUpdateSchoolData({home_phone: {...data?.home_phone, last: formatNum(e.target.value)}})}
          /> 
        </Space>
      )
    },
    {
      key: '7',
      label: '가맹유형',
      children: (
        <Radio.Group
          options={storeSchoolTypeOptions}
          value={data?.school_type}
          onChange={(e) => {
            fnUpdateSchoolData({school_type: e.target.value });
          }}
          disabled
        />
      )
    },
    {
      key: '8', span:2,
      label: <span className='text-require'>주소</span>,
      children: 
        <Space direction={'vertical'} size={2}>
          <Space>
            <Input value={data?.zip_code} style={{ width: '10rem' }} disabled />
            <AddressModal fnUpdateAddr={(v) => fnUpdateSchoolData({zip_code: v.zipCode, addr: v.addr })} />
          </Space>

          <Input value={data?.addr} disabled style={{ width: '56rem' }} />
          <Input value={data?.addr_detail} onChange={(e) => fnUpdateSchoolData({addr_detail: e.target.value })} />
        </Space>
    },
    {
      key: '9',
      label: <span className='text-require'>교육원 상태</span>,
      children: (
        <Select 
          style={{width: '12rem'}} 
          options={schoolStatus} 
          value={data?.school_status} 
          onSelect={(e)=>fnUpdateSchoolData({school_status: e})} 
        />
      )
    },
    {
      key: '10',
      label: '우수 교육원',
      children: 
        <Select
          showSearch={false}
          mode={'multiple'}
          style={{ width: '100%' }}
          value={data?.grade_1_year}
          options={yearOptions('2025',0)}
          onChange={v => fnUpdateSchoolData({grade_1_year: v})}
        />   
    },
    {
      key: '11',
      label: (
        <>
          <div>개점여부/개점일</div>
          <div>(영업시작일)</div>
        </>
      ),
      children: (
        <Space size={3}>
          <Select
            style={{width: '8rem'}}
            value={data?.open_status}
            placeholder={'개점여부'}
            options={[
              { label: '개점', value: 1 },
              { label: '미개점', value: 0 }
            ]}
            onSelect={(e)=>fnUpdateSchoolData({open_status: e})} 
          />
          <BaseDatePicker
            style={{ width: '15rem' }}
            value={data?.open_date}
            onChange={(date) => {
              fnUpdateSchoolData({open_date: date})
            }}
          />
        </Space>
      )
    },
    {
      key: '12',
      label: '전문 교육원',
      children: 
        <Select
          showSearch={false}
          mode={'multiple'}
          style={{ width: '100%' }}
          value={data?.grade_2_year}
          options={yearOptions('2025',0)}
          onChange={v => fnUpdateSchoolData({grade_2_year: v})}
        />   
    },
    {
      key: '13',
      label: '계약일',
      children: (
        <BaseDatePicker
          style={{ width: '15rem' }}
          value={data?.contract_date}
          onChange={(date) => {
              fnUpdateSchoolData({contract_date:date})
          }}
        />

      )
    },
    {
      key: '14',
      label: '선임 교육원',
      children: 
        <Select
          showSearch={false}
          mode={'multiple'}
          style={{ width: '100%' }}
          value={data?.grade_3_year}
          options={yearOptions('2025',0)}
          onChange={v => fnUpdateSchoolData({grade_3_year: v})}
        />   
    },
    {
      key: '15',
      label: '오픈예정일',
      children: (
        <BaseDatePicker
          style={{ width: '15rem' }}
          value={data?.plan_open_date}
          onChange={(date) => {
            fnUpdateSchoolData({plan_open_date: date})
          }}
        />
      )
    },
    {
      key: '16',
      label: '수석 교육원',
      children: 
        <Select
          showSearch={false}
          mode={'multiple'}
          style={{ width: '100%' }}
          value={data?.grade_4_year}
          options={yearOptions('2025',0)}
          onChange={v => fnUpdateSchoolData({grade_4_year: v})}
        />   
    },
    {
      key: '17',
      label: '참관수업일',
      children: (
        <BaseDatePicker
          style={{ width: '15rem' }}
          value={data?.observe_school_class_date}
          onChange={(date) => fnUpdateSchoolData({observe_school_class_date:date})}
        />
      )
    },
    {
      key: '18',
      label: '명예의 전당',
      children: 
        <Select
          showSearch={false}
          mode={'multiple'}
          style={{ width: '100%' }}
          value={data?.grade_5_year}
          options={yearOptions('2025',0)}
          onChange={v => fnUpdateSchoolData({grade_5_year: v})}
        />   
    },
    {
      key: '19', span: 2,
      label: <span className='text-require'>교육원장명</span>,
      children: <Input value={data?.school_leader_name} style={{ width: '25rem' }} onChange={(e) => fnUpdateSchoolData({school_leader_name: e.target.value })} />
    },
    {
      key: '20',
      label: <span className='text-require'>성별</span>,
      children: (
        <>
          <Radio.Group
            onChange={(e) => {
              fnUpdateSchoolData({gender: e.target.value });
            }}
            value={data?.gender}
          >
            <Radio value={'M'}>남자</Radio>
            <Radio value={'F'}>여자</Radio>
          </Radio.Group>
        </>
      )
    },
    {
      key: '21',
      label: <span className='text-require'>휴대폰번호</span>,
      children: (
        <Space>
          <Select
            value={data?.cell_phone?.first}
            style={{ width: '10rem' }}
            options={[{value: '010'}]}
            onSelect={(v) => fnUpdateSchoolData({cell_phone: {...data?.cell_phone, first: v}})}
          />       
          <Input 
            style={{ width: '13.5rem' }} 
            value={data?.cell_phone?.middle}
            onChange={(e) => fnUpdateSchoolData({cell_phone: {...data?.cell_phone, middle: formatNum(e.target.value)}})}
            maxLength={4}
          /> 
          - 
          <Input 
            style={{ width: '13.5rem' }} 
            value={data?.cell_phone?.last}
            onChange={(e) => fnUpdateSchoolData({cell_phone: {...data?.cell_phone, last: formatNum(e.target.value)}})}
            maxLength={4}
          /> 
        </Space>
      )
    },
    {
      key: '22',
      label: '생년월일',
      children: (
        <Space>
          <BaseDatePicker
            style={{ width: '15rem' }}
            value={data?.birth}
            onChange={(date) => {
              fnUpdateSchoolData({birth:date})
            }}
          />
        </Space>
      )
    },
    {
      key: '23',
      label: '이메일',
      children: (
        <Space>
          <Input style={{ width: '12rem' }} value={data?.email?.id} onChange={e=>fnUpdateSchoolData({ email: {...data?.email, id:e.target.value} })} />
          @
          <Input 
            style={{ width: '12.5rem' }}
            value={data?.email?.addr}
            onChange={(e) => fnUpdateSchoolData({email: {...data?.email, addr: e.target.value}})}
            disabled={data?.email?.auto}
          />
          <Select
            style={{ width: '12rem' }}
            defaultValue={''}
            options={emailOptions}
            onSelect={fnSetEmail}
          />   
        </Space>
      )
    },
    {
      key: '24',
      label: '회원가입일',
      children: <Input value={data?.join_date} style={{ width: '25rem' }} disabled />
    },
    {
      key: '25',
      label: '최근접속일',
      children: <Input value={data?.last_access_date} style={{ width: '25rem' }} disabled />
    },
    {
      key: '26',
      label: 'IP',
      children: <Input value={data?.ip} style={{ width: '25rem' }} disabled />
    },
    {
      key: '27',
      label: '접근차단일',
      children: <Input value={data?.access_blocking_date} style={{ width: '25rem' }} disabled />
    },
    {
      key: '28', span: 2,
      label: '메모',
      children: <TextArea value={data?.memo} rows={5} placeholder="메모" maxLength={500} onChange={e => fnUpdateSchoolData({memo: e.target.value })} />
    },
    {
      key: '29', span: 2,
      label: '통장정보',
      children: 
        <Space direction={'vertical'} size={0}>
          <span className="text-red">※ 본인 명의의 계좌번호를 등록해 주시기 바랍니다.</span>
          <Space size={'middle'}>
            <Space size={5}>
              예금주:
              <Input 
                value={data?.account_owner} 
                placeholder="예금주"
                onChange={(e) => fnUpdateSchoolData({account_owner: e.target.value})} 
              />
            </Space>
            <Space size={5}>
              은행명:
              <Select
                options={bankCodeOptions} 
                value={data?.account_bank} 
                style={{width:'16rem'}} 
                placeholder='선택' 
                onSelect={(e)=> fnUpdateSchoolData({account_bank: e})}
              />
            </Space>
            <Space size={5}>
              계좌번호:
              <Input 
                value={data?.account_info} 
                placeholder="계좌번호" 
                style={{width:'259px'}} 
                onChange={(e) => fnUpdateSchoolData({account_info: e.target.value})} 
              />
            </Space>
          </Space>
        </Space>
    },
    {
      key: '30',
      label: '사업자 등록번호',
      children:
        <Space direction={'vertical'} size={2}>
          <Space>
            <Input 
              value={data?.business_no?.business_no_1} 
              style={{width: '5rem'}} 
              onChange={(e) => fnUpdateSchoolData({business_no: {...data?.business_no, business_no_1: e.target.value}})} maxLength={3} />
              -
            <Input 
              value={data?.business_no?.business_no_2}
              style={{width: '4rem'}}  
              onChange={(e) => fnUpdateSchoolData({business_no: {...data?.business_no, business_no_2: e.target.value}})} maxLength={2} />
              -
            <Input 
              value={data?.business_no?.business_no_3}
              style={{width: '6rem'}}  
              onChange={(e) => fnUpdateSchoolData({business_no: {...data?.business_no, business_no_3: e.target.value}})} maxLength={5} />
          </Space>
          <Space>
            <UploadFile
                data={data?.business_license}
                fileName={data?.business_license}
                onChange={(v) => fnUpdateSchoolData({business_license: v.origin_file_name, business_license_path: v.file_path})}
                onDelete={() => fnUpdateSchoolData({business_license: undefined, business_license_path: undefined})}
              />
          </Space>
        </Space>
    }
  ];

  return (
    <BaseSection>
      <BaseContainer>
        <Row>
          <Col span={24}>
            <Descriptions bordered column={2} labelStyle={{ width: '16rem' }} contentStyle={{ textAlign: 'left' }} items={items1} />
          </Col>
        </Row>
        <Divider className="divider" />
        <Row>
          <Col span={24}>
            <Flex justify="flex-end">
              <Space>
                <FillButton label="저장" backgroundColor="var(--color-gray03)" onClick={fnUpdateData} />
                <OutlinedButton label="목록" color={'var(--color-gray03)'} onClick={() => navigate(`${URL_ADMIN + URL_ADMIN_SCHOOL}${URL_ADMIN_SCHOOL_MANAGE}`, {state: {tab: tab}})} />
              </Space>
            </Flex>
          </Col>
        </Row>
      </BaseContainer>
    </BaseSection>
  );
}
